import { Box, Text } from '@factorialco/deprecated-design-system'
import { AtsFeedbackDetailFragment } from 'generated/resources/graphql'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'

import { ScoreRating } from 'modules/ats/components/ScoreRating'

interface Props {
  feedback: AtsFeedbackDetailFragment
  hideRating?: boolean
}

export const FeedbackAuthor = ({ feedback, hideRating }: Props) => {
  const { rating, access } = feedback
  const authorFullName = access?.fullName || i18n.t('ats.feedbacks.unknown_author')
  const extra = access ? {} : { color: 'grey700' as const }

  return (
    <Box gap="s8" flexDirection="row" alignItems="center" paddingBottom="s8">
      {access && <UserAvatar user={access} size="s40" />}
      <Text.Normal {...extra}>{authorFullName}</Text.Normal>
      {!hideRating && rating && <ScoreRating rating={rating} />}
    </Box>
  )
}
